import { Injectable } from '@angular/core';

import { EventType, GA4Event, GTMService } from '@personal-area/global/gtm';

@Injectable({ providedIn: 'root' })
export class LoginAnalyticsTrackingService {

  constructor(private _gtmService: GTMService) {
  }

  public trackSignUp(method, user): void {
    this._gtmService.event(EventType.SignUp, <GA4Event>{
      context: 'signup',
      object: 'signup',
      action: 'completed',
      method,
      user
    });
  }

  public trackLogin(method, user): void {
    this._gtmService.event(EventType.Login, <GA4Event>{
      context: 'login',
      object: 'login',
      action: 'completed',
      method,
      user
    });
  }
}
